<template>
    <v-container>
        <v-row class="text-center">
            <v-col cols="12" v-for="video in videos" :key="video.id">
                <jazz-video :video="video" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import JazzVideo from './JazzVideo'

export default {
    name: 'jazz-videos',
    components: { JazzVideo },
    computed: {
        videos() {
            return this.$store.getters.videos
        }
    },

    mounted() {
        return this.$store.dispatch('videos')
    }
}
</script>
